const keyBMW = '^BMW';
const keyMoto = '^BMW Motorrad';
const keyM = '^BMW M';
const keyMini = '^MINI';
const keyGebraucht = '-3^BMW Gebrauchtwagen';
const keyUsedCar = '-4^BMW Used Car';
const keyUsedBike = '-5^BMW Used Bike';
const keyUsedCarBELU = '-6^BMW Used Car BE / LU';
const keyI1 = '^BMWi';
const keyI2 = '^BMW i';
const keyI3 = '^xEV (BMW i)';

function handleArray(brandArray, check) {
  if (_.isEmpty(brandArray)) {
    return false;
  } else {
    for (var i = 0; i < brandArray.length; i++) {
      if (brandArray[i].endsWith(check)) {
        return true;
      }
    }
    return false;
  }
}

export default {
  methods: {
    getIsBMW: function(brand) {
      return _.isArray(brand) ? handleArray(brand, keyBMW) : brand.endsWith(keyBMW);
    },
    getIsBmwMoto: function(brand) {
      return _.isArray(brand) ? handleArray(brand, keyMoto) : brand.endsWith(keyMoto);
    },
    getIsBMWM: function(brand) {
      return _.isArray(brand) ? handleArray(brand, keyM) : brand.endsWith(keyM);
    },
    getIsMini: function(brand) {
      return _.isArray(brand) ? handleArray(brand, keyMini) : brand.endsWith(keyMini);
    },
    getIsBMWi: function(brand) {
      return _.isArray(brand) ? handleArray(brand, keyI3) : brand.endsWith(keyI3);
    },
    getIsGebrauchtwagen: function(brand) {
      return _.isArray(brand) ? handleArray(brand, keyGebraucht) : brand.endsWith(keyGebraucht);
    },
    getIsUsedCar: function(brand) {
      return _.isArray(brand) ?
        handleArray(brand, keyUsedCar) || handleArray(brand, keyUsedCarBELU) :
        brand.endsWith(keyUsedCar) || brand.endsWith(keyUsedCarBELU);
    },
    getIsUsedCar2021: function(brand) {
      let res =  _.isArray(brand) ?
        brand[0].startsWith('u') :
        false;
        return res;
    },
    getIsUsedBike: function(brand) {
      return _.isArray(brand) ? handleArray(brand, keyUsedBike) : brand.endsWith(keyUsedBike);
    },
    getIsBmw2020: function(data, _this) {
      if (_.isEmpty(data) || _.isEmpty(data.OverallByWave) || _.isEmpty(data.OverallByWave[0].SurveyWave)) {
        return false;
      }

      if (_this.isBmwM || _this.isBmwMoto || _this.isGebrauchtwagen || _this.isUsedCar || _this.isUsedBike) {
        return false;
      }

      for (var i = 0; i < data.OverallByWave[0].SurveyWave.length; i++) {
        if (data.OverallByWave[0].SurveyWave[i].Name.includes('20')) {
          return true;
        }
      }
      return false;
    },
    visualizeExcitement(options) {
      return options
          && options._visuals
          && options._visuals.length === 1
          && options._visuals[0].excitement === 1;
    },
  }
};
